import { OPEN_FILE_VIEWER, CLOSE_FILE_VIEWER } from "./actionsType";

const initialState = {
  isOpen: false,
  file: null,
};

const FileViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_FILE_VIEWER:
      return {
        ...state,
        isOpen: true,
        file: action.payload,
      };

    case CLOSE_FILE_VIEWER:
      return {
        ...state,
        isOpen: false,
        file: null,
      };
    default:
      return state;
  }
};
export default FileViewerReducer;
